// utils
import createAvatar from "../utils/createAvatar";
//
import Avatar from "./Avatar";

// ----------------------------------------------------------------------

export default function TeamAvatar({ team, sx = {} }) {
  return (
    <Avatar
      sx={{ width: 30, height: 30, ...sx }}
      src={team.picture}
      alt={team.name}
      color={team.picture ? "default" : createAvatar(team.name).color}
    >
      {createAvatar(team.name).name}
    </Avatar>
  );
}
